import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import { group } from 'console';
import React from 'react';
interface CardProps {
  item: string;
}
export const SkeletonList = () => {
  return (
    <Card sx={{ maxWidth: 345, minHeight: 600 }}>
      <Skeleton variant="rectangular" width={345} height={230} />
      <div className="card__content">
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            <Skeleton />
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}></Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: 230,
              fontSize: 16,
            }}
          >
            <Box>
              <Typography variant="body1">
                <Skeleton />
              </Typography>
              <Typography variant="body1">
                <Skeleton />
              </Typography>
              <Typography variant="body1">
                <Skeleton />
              </Typography>
              <Typography variant="body1">
                <Skeleton />
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </div>
    </Card>
  );
};
